import {Injectable} from "@angular/core";
import {Tab} from "./tab.model";
import {BehaviorSubject} from "rxjs";
import {importHelper} from "../Multitab/importHelper";
import {Router, ActivatedRoute} from '@angular/router';

@Injectable()
export class TabService {
    public tabs: Tab[] = [
    ];

    public tabSub = new BehaviorSubject<Tab[]>(this.tabs);
    constructor(private importHelper: importHelper, private router: Router) {

    }
    public removeTab(index: number) {
        this.tabs.splice(index, 1);
        if (this.tabs.length > 0) {
            this.tabs[this.tabs.length - 1].active = true;
        }
        this.tabSub.next(this.tabs);
        if (this.tabs.length > 0) {
        } else {
            this.router.navigate(['/home'], {skipLocationChange: true})
        }
    }

    public addTab(tab: Tab) {
        for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].active === true) {
                this.tabs[i].active = false;
            }
        }
        tab.id = this.tabs.length + 1;
        tab.active = true;
        this.tabs.push(tab);
        this.tabSub.next(this.tabs);

    }

    addTabfromrouter(isNewtab, router, currentId?: number,tabHeading?:any) {
        console.log("addTabfromrouter..", currentId);
            let currentModule = this.importHelper.moduleDetails.find(mod => mod.router == router);
            if (currentModule) {
                if (isNewtab == false) {
                    this.closeallTabs();
                }
                this.addTab(
                    new Tab(currentModule.heading, {parent: ""}, router, isNewtab,currentId,tabHeading)
                );
            }       
    }

    closeallTabs() {
        this.tabs = new Array();
        this.tabSub.next(this.tabs);
    }

    checkActiveTabs(currentId: number): boolean {
        let openedTabindex: any = null;
        let isActive: boolean = false;
        if (this.tabs.length > 0) {
            if (currentId) {
                openedTabindex = this.tabs.findIndex(data => data.currentId == currentId);
                console.log("openedTabindex..", openedTabindex);
                if (openedTabindex != -1) {
                    isActive = true;
                    for (let i = 0; i < this.tabs.length; i++) {
                        if (this.tabs[i].active === true) {
                            this.tabs[i].active = false;
                        }
                    }
                    this.tabs[openedTabindex].active = true;
                    this.tabSub.next(this.tabs);
                }
            }
        }
        console.log("isActive..", isActive);
        return isActive;
    }
}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/Multitab/tab.service.ts